module.exports = __webpack_public_path__ + "img/icon-mhyc.fcfadaa2.png";